"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nHydrationManager = void 0;
const audi_i18n_context_1 = require("@volkswagen-onehub/audi-i18n-context");
const oneaudi_os_utils_1 = require("@volkswagen-onehub/oneaudi-os-utils");
const react_1 = __importStar(require("react"));
const I18nHydrationManager = ({ language, loader, rehydratedI18nStore = "oadd-i18n-hydration-store", children, }) => {
    const i18nContext = (0, react_1.useContext)((0, audi_i18n_context_1.getI18NContext)());
    const rehydratedI18nData = (0, react_1.useRef)((0, oneaudi_os_utils_1.rehydrateValue)(rehydratedI18nStore));
    if (!i18nContext) {
        throw new Error("i18nContext is undefined. Did you forget to wrap I18nHydrationManager with I18nContextComponent from audi-i18n-context?");
    }
    const { i18nState } = i18nContext;
    (0, react_1.useEffect)(() => {
        var _a;
        if (i18nState.i18nData && i18nState.i18nData[language]) {
            // eslint-disable-next-line no-underscore-dangle
            if (!((_a = window.__INITIAL__DATA__) === null || _a === void 0 ? void 0 : _a[rehydratedI18nStore])) {
                (0, oneaudi_os_utils_1.storeForHydration)(`oadd-i18n-hydration-store`, i18nState.i18nData[language]);
            }
        }
    }, [i18nState, language, rehydratedI18nStore]);
    if (!i18nState.i18nData && !rehydratedI18nData.current) {
        return react_1.default.createElement(react_1.default.Fragment, null, loader);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.I18nHydrationManager = I18nHydrationManager;
//# sourceMappingURL=I18nHydrationManager.js.map